import { WEB_BASE_URL } from '../../config/app';

const getEnvWebBase = () => {
  return WEB_BASE_URL || process.env.REACT_APP_WEB_URL || process.env.VITE_WEB_URL || '';
};

export const getPublicLiveAuctionPath = (tournamentId) =>
  tournamentId ? `/public/tournaments/${tournamentId}/live-auction` : '';

export const getPublicOnlineAuctionPath = (tournamentIdOrToken) =>
  tournamentIdOrToken ? `/public/auction/${encodeURIComponent(tournamentIdOrToken)}` : '';

export const buildPublicAuctionUrl = (tournament) => {
  const publicId =
    tournament?.auctionPublicToken ||
    tournament?.publicToken ||
    tournament?.joinLinkToken ||
    tournament?._id ||
    tournament?.id ||
    (typeof tournament === 'string' ? tournament : '');

  if (!publicId) return '';

  const envWebUrl = getEnvWebBase();
  const webBase = (envWebUrl || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/+$/, '');
  const generatedUrl = `${webBase}/public/auction/${encodeURIComponent(publicId)}`;

  console.log('PUBLIC_AUCTION_LINK_DEBUG', {
    webBase,
    publicId,
    generatedUrl,
    envWebUrl,
    platform: 'web',
  });

  return generatedUrl;
};

export const toAbsolutePublicUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const webBase = (getEnvWebBase() || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/+$/, '');
  return `${webBase}${path}`;
};
